import * as Scrivito from "scrivito";
import defaultFormInputAttributes from "../../_defaultFormAttributes";

const InputWidget = Scrivito.provideWidgetClass("InputWidget", {
  attributes: {
    ...defaultFormInputAttributes,
    propertyName: [
      "enum",
      {
        values: ["email", "text"],
      },
    ],
    placeholder: "string",
  },
  onlyInside: "FormPageWidget",
});

export default InputWidget;
